import ChevronLeft from '@material-ui/icons/ChevronLeft';
import PropTypes from 'prop-types';
import React from 'react';

const AdTypeMenuHeading = ({ title, onClick }) => (
  <div
    onClick={onClick}
    className="ad-type-nav p1"
    role="presentation"
    data-testid="ad-type-menu-heading"
  >
    <ChevronLeft
      style={{ fontSize: 30, verticalAlign: 'middle' }}
      className="nav-chevron"
    />
    <span>{title}</span>
  </div>
);

AdTypeMenuHeading.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
};

export default AdTypeMenuHeading;
